import { PAY_PERIOD_DATES } from './payPeriod19'

/**
 * docs/product/scheduling-model.md's "Request horizon": agents may submit
 * within the current pay period and the pay periods that follow it, up to
 * this many. The default, and the only value there is a way to configure
 * yet (no administration screen exists), is 3. Split into its own file
 * so AgentRequestLeavePage.tsx only exports the component, which Fast
 * Refresh requires, and so the underlying date math is testable directly.
 */
export const REQUEST_HORIZON_PAY_PERIODS = 3
const PAY_PERIOD_LENGTH_DAYS = 14

function toISO(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

// Pay Period 19's own start anchors every period after it too, on the same
// fixed 14-day cadence: the horizon has to advance with the real current
// date, not stay fixed to this one pilot period's own end, or it freezes
// solid the day the real date finally moves past it.
const PAY_PERIOD_ANCHOR_START = PAY_PERIOD_DATES[0].date

function currentPayPeriodEnd(todayISO: string): Date {
  const [anchorYear, anchorMonth, anchorDay] = PAY_PERIOD_ANCHOR_START.split('-').map(Number)
  const anchorStart = new Date(anchorYear, anchorMonth - 1, anchorDay)
  const [year, month, day] = todayISO.split('-').map(Number)
  const today = new Date(year, month - 1, day)
  const daysSinceAnchor = Math.floor((today.getTime() - anchorStart.getTime()) / (24 * 60 * 60 * 1000))
  const periodsElapsed = Math.floor(daysSinceAnchor / PAY_PERIOD_LENGTH_DAYS)
  const periodEnd = new Date(anchorStart)
  periodEnd.setDate(periodEnd.getDate() + (periodsElapsed + 1) * PAY_PERIOD_LENGTH_DAYS - 1)
  return periodEnd
}

// The end of whichever pay period contains the given date, plus the
// horizon's full span beyond it: leave cannot be requested for a date past
// this. Takes today as a parameter, not a closed-over global, so it is
// exercised directly in tests against dates the real clock will not reach
// for years, rather than only ever against whatever today happens to be.
export function requestHorizonEndFor(todayISO: string): string {
  const end = currentPayPeriodEnd(todayISO)
  end.setDate(end.getDate() + REQUEST_HORIZON_PAY_PERIODS * PAY_PERIOD_LENGTH_DAYS)
  return toISO(end)
}
